import type { NodeDetailArgs } from 'components/DeviceView/deviceViewTypes';
import { getDeviceViewEntityNodeId } from 'components/DeviceView/helpers/getDeviceViewEntityNodeId';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';
import { showTable } from './showTable';

export type ShowNodeDetailCommand = NodeDetailArgs;

export const showNodeDetail: DeviceViewCommandFactory<ShowNodeDetailCommand> =
  (cmdContext, dispatch) => (command) => {
    const deviceViewEntityId = getDeviceViewEntityNodeId(command.sn);
    // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: opening and updating an explorer entity must be one atomic state transition
    cmdContext.updateState((draft) => {
      // Prevent reopening panel if node is detached
      if (
        !draft.deviceViewWindows.some((win) => win.id === deviceViewEntityId)
      ) {
        draft.deviceViewOpen = true;
        draft.activeDeviceViewEntityId = deviceViewEntityId;
        cmdContext
          .getState()
          .handlersContainer.handleActiveDeviceEntityChange?.({
            deviceViewElement: 'node',
            deviceViewEntityId,
          });
      }

      const existingEntity = draft.deviceViewEntities.find(
        (entity) => entity.id === deviceViewEntityId,
      );

      if (existingEntity === undefined) {
        draft.deviceViewEntities.unshift({
          compareMode: command.compareMode,
          deviceId: command.deviceId,
          deviceViewElement: 'node',
          extra: command.extra,
          id: deviceViewEntityId,
          intentCheckResult: command.intentCheckResult,
          isPathLookupNode: !!command.isPathLookupNode,
          labelsTabs: command.labelsTabs ?? [],
          nodeHasPathInspectorDetail: !!command.nodeHasPathInspectorDetail,
          nodeType: command.nodeType,
          parentNodeSn: command.parentNodeSn,
          parentNodeType: command.parentNodeType,
          sn: command.sn,
          table: null,
          tableFilters: {},
          tableSort: {},
          title: command.title,
          ...(command.redirectToTable !== undefined &&
            !draft.settings.nodesLoaded && {
              redirectToTable: command.redirectToTable,
            }),
        });
      } else if (existingEntity.deviceViewElement === 'node') {
        if (command.deviceId !== undefined) {
          existingEntity.deviceId = command.deviceId;
        }
        if (command.labelsTabs !== undefined) {
          existingEntity.labelsTabs = command.labelsTabs;
        }
      }
    });

    if (
      command.redirectToTable !== undefined &&
      cmdContext.getState().settings.nodesLoaded
    ) {
      dispatch(showTable, {
        deviceViewEntityId,
        webEndpoint: command.redirectToTable,
      });
    }
  };
